import { 
  Youtube, 
  Play, 
  Users, 
  BookOpen, 
  Download, 
  ExternalLink,
  Clock,
  TrendingUp
} from 'lucide-react';
import PromotionalBanner from '../components/ui/PromotionalBanner';

const ResourcesPage = () => {
  const channelStats = {
    subscribers: '125K+',
    videos: '1500+',
    views: '20M+',
    uploads: 'Weekly'
  };

  const featuredPlaylists = [
    {
      title: 'Using Gen AI & AI Agent in Software Automation Testing',
      description: 'Complete guide to leveraging Generative AI for modern software testing practices.',
      videoCount: 25,
      duration: '6.5 hours',
      thumbnail: 'https://img.youtube.com/vi/BfC_Lk3NVSs/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=BfC_Lk3NVSs&list=PL6tu16kXT9PrwguFCbsiiOmFsBSrRviPN',
      category: 'AI Testing'
    },
    {
      title: 'Basic Software Testing Knowledge',
      description: 'Essential software testing concepts and fundamentals for beginners.',
      videoCount: 20,
      duration: '5.2 hours',
      thumbnail: 'https://img.youtube.com/vi/bISJfIm-x-U/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=bISJfIm-x-U&list=PL6tu16kXT9PpLdKpVlZ1vFNt1j96Bs0m5',
      category: 'Fundamentals'
    },
    {
      title: 'AI QA Engineering',
      description: 'Advanced AI techniques for Quality Assurance and automated testing.',
      videoCount: 18,
      duration: '4.8 hours',
      thumbnail: 'https://img.youtube.com/vi/1wYIns_lwiY/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=1wYIns_lwiY&list=PL6tu16kXT9PrFiqBeH-dibrhhqQEpmIs6',
      category: 'AI Testing'
    },
    {
      title: 'Playwright with C# .NET',
      description: 'Modern web testing with Playwright using C# .NET for reliable automation.',
      videoCount: 35,
      duration: '9.2 hours',
      thumbnail: 'https://img.youtube.com/vi/5i53YLWD_QI/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=5i53YLWD_QI&list=PL6tu16kXT9PoUv6HwexX5LPBzzv7QkI9W',
      category: 'Automation'
    },
    {
      title: 'BDD with ReqnRoll',
      description: 'Behavior-Driven Development practices using ReqnRoll framework.',
      videoCount: 15,
      duration: '3.8 hours',
      thumbnail: 'https://img.youtube.com/vi/8qedP-YX2-E/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=8qedP-YX2-E&list=PL6tu16kXT9PpqWrAYzhnlulMTKU2aP58P',
      category: 'BDD'
    },
    {
      title: 'Selenium with Java (Basic to Advanced)',
      description: 'Comprehensive Selenium WebDriver course with Java from basics to advanced.',
      videoCount: 45,
      duration: '12.5 hours',
      thumbnail: 'https://img.youtube.com/vi/1VcRIymrXbI/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=1VcRIymrXbI&list=PL6tu16kXT9PqixJLqvRWDIIOtGJTzOpQG',
      category: 'Automation'
    },
    {
      title: 'Selenium with C# .NET',
      description: 'Master Selenium WebDriver with C# .NET for robust test automation.',
      videoCount: 40,
      duration: '11.2 hours',
      thumbnail: 'https://img.youtube.com/vi/ANHMNIUPNSY/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=ANHMNIUPNSY&list=PL6tu16kXT9Pr50Bu96uf9z4rNxMTVTIxm',
      category: 'Automation'
    },
    {
      title: 'WireMock .NET',
      description: 'API mocking and testing with WireMock .NET for effective service virtualization.',
      videoCount: 12,
      duration: '3.2 hours',
      thumbnail: 'https://img.youtube.com/vi/SQRPqBWHeJs/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=SQRPqBWHeJs&list=PL6tu16kXT9Pr-y-moJz03XkZLH1ir4O_S',
      category: 'API Testing'
    },
    {
      title: 'C# for Testers',
      description: 'Essential C# programming skills specifically designed for software testers.',
      videoCount: 22,
      duration: '6.8 hours',
      thumbnail: 'https://img.youtube.com/vi/ZsWGfbgBXsw/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=ZsWGfbgBXsw&list=PL6tu16kXT9Pp3NFZgLbPZXEykeGQwxGSx',
      category: 'Programming'
    },
    {
      title: 'Kubernetes for Testers',
      description: 'Understanding Kubernetes from a testing perspective and container orchestration.',
      videoCount: 16,
      duration: '4.5 hours',
      thumbnail: 'https://img.youtube.com/vi/w4MiaZBI0oQ/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=w4MiaZBI0oQ&list=PL6tu16kXT9PpKXQADb8AyJ1zHyp7xDHHo',
      category: 'DevOps'
    },
    {
      title: 'PyTest for Python Testers',
      description: 'Complete guide to PyTest from the ground up — writing tests, working with classes, fixtures, and best practices for Python automation.',
      videoCount: 2,
      duration: 'In Progress',
      thumbnail: 'https://img.youtube.com/vi/IpeyumlDVkE/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=IpeyumlDVkE',
      category: 'Automation'
    }
  ];

  const recentVideos = [
    {
      title: 'E2E Testing of AI Apps - ChatBot, RAGs, MCP Servers with DeepEval (New Course) 🚀',
      description: 'Build end-to-end tests for AI-powered apps including ChatBots, RAGs, and MCP Servers using DeepEval, PyTest, Ollama, and LangChain.',
      duration: '10:16',
      views: '743',
      uploadDate: '2 days ago',
      thumbnail: 'https://img.youtube.com/vi/ra4JX-2C1MU/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=ra4JX-2C1MU'
    },
    {
      title: 'How to Test SSE & WebSocket Applications Using TestSprite AI Agent',
      description: 'Learn how to test real-time SSE and WebSocket applications — live chat, collaborative editing, and live notifications — using TestSprite AI Agent.',
      duration: '9:49',
      views: '256',
      uploadDate: '3 days ago',
      thumbnail: 'https://img.youtube.com/vi/2cLJN4IJdxQ/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=2cLJN4IJdxQ'
    },
    {
      title: 'Claude Code Wasted 100K Tokens. Pi Did It Better on Local Gemma 4',
      description: 'A performance comparison of Claude Code vs Pi running on local Gemma 4, plus an in-depth look at Copilot\'s quiet capability downgrade.',
      duration: '19:09',
      views: '1K',
      uploadDate: '1 week ago',
      thumbnail: 'https://img.youtube.com/vi/_u4PLnc13ME/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=_u4PLnc13ME'
    }
  ];

  const downloadableResources = [
    {
      title: 'GitHub Repository',
      description: 'Access all source code, frameworks, and examples from our courses.',
      type: 'GitHub',
      size: 'Repository',
      downloads: '5K+',
      link: 'http://github.com/executeautomation'
    },
    {
      title: 'Free Automation Testing Site',
      description: 'Practice web automation testing with our dedicated test application.',
      type: 'Web App',
      size: 'Live Site',
      downloads: '25K+',
      link: 'http://eaapp.somee.com'
    },
    {
      title: 'Free API Testing Site',
      description: 'Practice API testing with our comprehensive Swagger API endpoints.',
      type: 'API',
      size: 'Live API',
      downloads: '18K+',
      link: 'http://eaapi.somee.com/swagger/index.html'
    }
  ];

  const categories = ['All', 'AI Testing', 'Fundamentals', 'Automation', 'BDD', 'API Testing', 'Programming', 'DevOps'];

  return (
    <div className="space-y-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-20" id="main">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-6">
              <div className="p-4 bg-red-500 rounded-2xl shadow-lg">
                <Youtube className="h-12 w-12 text-white" aria-label="Youtube icon" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Free Learning Resources
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
              Access our comprehensive library of free educational content, tutorials, and resources 
              to accelerate your journey in AI testing and automation.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="http://youtube.com/executeautomation"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-red-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-red-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-red-500/25"
              >
                <Youtube className="h-6 w-6" aria-label="Youtube icon" />
                Subscribe to Channel
                <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
              </a>
              <button className="inline-flex items-center gap-3 bg-gray-100 text-gray-800 px-8 py-4 rounded-full font-semibold hover:bg-gray-200 transition-all duration-300">
                <BookOpen className="h-6 w-6" aria-label="BookOpen icon" />
                Browse All Resources
              </button>
            </div>
          </div>

          {/* Channel Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {Object.entries(channelStats).map(([key, value], index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
                <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{value}</div>
                <div className="text-gray-600 capitalize font-medium">{key}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Promotional Banner */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <PromotionalBanner variant="inline" />
      </section>

      {/* Featured Playlists */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured Playlists
          </h2>
          <p className="text-xl text-gray-600">
            Curated learning paths for different skill levels and interests
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              className="px-6 py-2 rounded-full bg-gray-100 text-gray-700 font-medium hover:bg-blue-100 hover:text-blue-700 transition-colors duration-200"
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredPlaylists.map((playlist, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              <div className="relative">
                <img 
                  src={playlist.thumbnail} 
                  alt={playlist.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300"></div>
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-blue-600 rounded-full">
                    {playlist.category}
                  </span>
                </div>
                <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {playlist.videoCount} videos
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {playlist.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {playlist.description}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center gap-1">
                    <Clock className="h-4 w-4" aria-label="Clock icon" />
                    {playlist.duration}
                  </div>
                  <div className="flex items-center gap-1">
                    <Play className="h-4 w-4" aria-label="Play icon" />
                    {playlist.videoCount} videos
                  </div>
                </div>
                <a
                  href={playlist.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 w-full justify-center"
                >
                  <Play className="h-4 w-4" aria-label="Play icon" />
                  Watch Playlist
                  <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Recent Videos */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Latest Videos
            </h2>
            <p className="text-xl text-gray-600">
              Stay updated with our newest content and tutorials
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {recentVideos.map((video, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
                <div className="relative">
                  <img 
                    src={video.thumbnail} 
                    alt={video.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <div className="bg-white/20 backdrop-blur-sm rounded-full p-4 group-hover:bg-white/30 transition-colors duration-300">
                      <Play className="h-8 w-8 text-white" aria-label="Play icon" />
                    </div>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-black/70 text-white px-2 py-1 rounded text-sm font-medium">
                    {video.duration}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2">
                    {video.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm line-clamp-2">
                    {video.description}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                    <div className="flex items-center gap-4">
                      <span>{video.views} views</span>
                      <span>{video.uploadDate}</span>
                    </div>
                  </div>
                  <a
                    href={video.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-blue-600 font-medium hover:text-blue-700 transition-colors duration-200"
                  >
                    <Play className="h-4 w-4" aria-label="Play icon" />
                    Watch Now
                    <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="http://youtube.com/executeautomation"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-red-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-red-600 transition-all duration-300 transform hover:scale-105"
            >
              <Youtube className="h-6 w-6" aria-label="Youtube icon" />
              View All Videos
              <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
            </a>
          </div>
        </div>
      </section>

      {/* Free Resources */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Free Resources
          </h2>
          <p className="text-xl text-gray-600">
            Free resources to enhance your testing skills
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {downloadableResources.map((resource, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-100 rounded-lg">
                  <Download className="h-6 w-6 text-green-600" aria-label="Download icon" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {resource.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm">
                    {resource.description}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                    <span className="bg-gray-100 px-2 py-1 rounded">{resource.type}</span>
                    <span>{resource.size}</span>
                    <div className="flex items-center gap-1">
                      <TrendingUp className="h-4 w-4" aria-label="TrendingUp icon" />
                      {resource.downloads}
                    </div>
                  </div>
                  <a
                    href={resource.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-green-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-green-700 transition-colors duration-200 flex items-center justify-center gap-2"
                  >
                    <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
                    Access Free
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Community Section */}
      <section className="bg-gradient-to-br from-blue-600 to-purple-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Join Our Learning Community
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Connect with fellow automation enthusiasts, get your questions answered, 
            and stay updated with the latest in AI testing.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="http://youtube.com/executeautomation"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-blue-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
            >
              <Youtube className="h-6 w-6" aria-label="Youtube icon" />
              Subscribe & Join
              <ExternalLink className="h-4 w-4" aria-label="ExternalLink icon" />
            </a>
            <div className="flex items-center gap-2 text-blue-100">
              <Users className="h-5 w-5" aria-label="Users icon" />
              <span className="font-medium">125K+ subscribers already joined</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesPage;